import { render, staticRenderFns } from "./AddToClass.vue?vue&type=template&id=c9e684ca&scoped=true"
import script from "./AddToClass.vue?vue&type=script&lang=js"
export * from "./AddToClass.vue?vue&type=script&lang=js"
import style0 from "./AddToClass.vue?vue&type=style&index=0&id=c9e684ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e684ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VSpacer})
